import actionTypes from './actionTypes';

const requestData = () => ({
    type: actionTypes.FETCH_DATA_REQUEST,
});

const fetchDataFailure = (error) => ({
    type: actionTypes.FETCH_DATA_FAILURE,
    payload: {
        error,
    },
});

const fetchDataSuccess = (dataset) => ({
    type: actionTypes.FETCH_DATA_SUCCESS,
    payload: {
        dataset,
    },
});

const hydrateSort = (sortData) => ({
    type: actionTypes.HYDRATE_SORT,
    payload: {
        sortData,
    },
});

const setSort = (sortData) => ({
    type: actionTypes.SET_SORT,
    payload: {
        sortData,
    },
});

const resetSort = (sortData) => ({
    type: actionTypes.RESET_SORT,
    payload: {
        sortData,
    },
});

const setPage = (page) => ({
    type: actionTypes.SET_PAGE,
    payload: {
        page,
    },
});

const setPageSize = (pageSize) => ({
    type: actionTypes.SET_PAGE_SIZE,
    payload: {
        pageSize,
    },
});

const hydratePage = (page) => ({
    type: actionTypes.HYDRATE_PAGE,
    payload: {
        page,
    },
});

const hydratePageSize = (pageSize) => ({
    type: actionTypes.HYDRATE_PAGE_SIZE,
    payload: {
        pageSize,
    },
});

const resetPagination = () => ({
    type: actionTypes.RESET_PAGINATION,
});

export default {
    requestData,
    fetchDataFailure,
    fetchDataSuccess,
    hydrateSort,
    setSort,
    resetSort,
    setPage,
    setPageSize,
    hydratePage,
    hydratePageSize,
    resetPagination,
};
